export const T = {
  en_GB: {
    webhookDeliveryLogs: "Webhook Delivery Logs",
    recentDeliveriesFor: "Recent deliveries for",
    success: "Success",
    failed: "Failed",
    pending: "Pending",
    refresh: "Refresh",
    loading: "Loading...",
    recentDeliveries: "Recent Deliveries",
    test: "Test",
    attempt: "Attempt",
    noDeliveriesYet: "No deliveries yet. Webhooks will appear here when events are triggered.",
    deliveryDetails: "Delivery Details",
    selectDeliveryToView: "Select a delivery to view details",
    status: "Status",
    eventType: "Event Type:",
    eventId: "Event ID:",
    url: "URL:",
    httpStatus: "HTTP Status:",
    duration: "Duration:",
    attempts: "Attempts:",
    created: "Created:",
    requestPayload: "Request Payload",
    responseBody: "Response Body",
    notAvailable: "N/A",
  },
  nb_NO: {
    webhookDeliveryLogs: "Webhook-leveringslogger",
    recentDeliveriesFor: "Nylige leveringer for",
    success: "Vellykket",
    failed: "Mislyktes",
    pending: "Venter",
    refresh: "Oppdater",
    loading: "Laster...",
    recentDeliveries: "Nylige leveringer",
    test: "Test",
    attempt: "Forsøk",
    noDeliveriesYet: "Ingen leveringer ennå. Webhooks vises her når hendelser utløses.",
    deliveryDetails: "Leveringsdetaljer",
    selectDeliveryToView: "Velg en levering for å se detaljer",
    status: "Status",
    eventType: "Hendelsestype:",
    eventId: "Hendelses-ID:",
    url: "URL:",
    httpStatus: "HTTP-status:",
    duration: "Varighet:",
    attempts: "Forsøk:",
    created: "Opprettet:",
    requestPayload: "Forespørselsdata",
    responseBody: "Svarkropp",
    notAvailable: "N/A",
  },
} as const;
